// 球员卡
const playerList = [
  {
    typeName: ['足球'],
    template: 'Fk9IKSagGymv6YFnmSfigI4egFcO',
    model: '暗金之刃',
    id: '25',
  },
  {
    typeName: ['足球'],
    template: 'FmVON_NZhuGj3hQzkEbESkfGGIA8',
    model: '炫影蓝魔',
    id: '26',
  },
  {
    typeName: ['足球'],
    template: 'Fj41GjL6yZv3DJMgBZFt9ZmdJx2w',
    model: '绿茵荣耀',
    id: '76',
  },
  {
    typeName: ['足球'],
    template: 'FgMi6smFCdfYvyjk9NkJ9KqiB6FC',
    model: '沙场狂飙',
    id: '77',
  },
  {
    typeName: ['足球'],
    template: 'Fogbae4TPm_g0Ekmj594uR-8xVL3',
    model: '疾速闪耀-方形',
    id: '27',
  },
  {
    typeName: ['足球'],
    template: 'FgSaeZgbciulsZN0ULwKCtwV3FtK',
    model: '金色绿茵',
    id: '28',
  },
  {
    typeName: ['足球'],
    template: 'FsdA6BSAiQUQFF_UDenHA892uq9S',
    model: '炽热星辰',
    id: '29',
  },
  {
    typeName: ['冰球'],
    template: 'FqBo9hIm6K0zS_hcdwIaSp5fcrUK',
    model: '冰封时刻',
    id: '30',
  },
  {
    typeName: ['冰球'],
    template: 'FpEV7fm10fvdFu4gzB1U14ceVHfb',
    model: '冰河星光',
    id: '31',
  },
  {
    typeName: ['冰球'],
    template: 'FiGyyaT0U5hZSSq53TVAcE8cFb4A',
    model: '冰际幻影',
    id: '32',
  },
  {
    typeName: ['冰球'],
    template: 'Fj9K_s-uqF-QdtdM6Jrt1Ey0eOGy',
    model: '冻结幻境',
    id: '33',
  },
  {
    typeName: ['冰球'],
    template: 'Fm-IuzPhAkcJXgs_AkaurFrU3D3k',
    model: '寒光炫舞',
    id: '34',
  },
  {
    typeName: ['橄榄球'],
    template: 'Fm857DrRakW9n6UyoGWLlV5mXTS1',
    model: '紫金巅峰',
    id: '35',
  },
  {
    typeName: ['橄榄球'],
    template: 'Fm0hsd8JnDwv38Y_55RjBnkPPjTl',
    model: '城市腰约',
    id: '36',
  },
  {
    typeName: ['橄榄球'],
    template: 'Fsmw66FaUhWn6FPww5d8tfD6f1Rw',
    model: '碧落星云',
    id: '37',
  },
  {
    typeName: ['橄榄球'],
    template: 'FvAi6ks29uYF_xmWfdQ-70MIoBIG',
    model: '雷霆冲锋',
    id: '38',
  },
  {
    typeName: ['橄榄球'],
    template: 'FkCHYLkJ1DZlEV0zngT6TZulKy_E',
    model: '青岚逐鹿',
    id: '39',
  },
  {
    typeName: ['橄榄球'],
    template: 'Ft-e5FDqvIJwyw7wcFwD3sckSZ-q',
    model: '闪电先锋',
    id: '40',
  },
  {
    typeName: ['橄榄球'],
    template: 'FrZ2-tyB1X0SVaSnVjoGk5BonDcL',
    model: '星辰斗士',
    id: '41',
  },
  {
    typeName: ['棒球'],
    template: 'FvHJY0AKYEBh4snpLbFxNcehftOM',
    model: '紫夜逐星',
    id: '42',
  },
  {
    typeName: ['棒球'],
    template: 'FmUV3kv3jEE5t5cqJ2M9SH5ezNJq',
    model: '苍翠劲风',
    id: '43',
  },
  {
    typeName: ['棒球'],
    template: 'Fm_ef8P1bjIWZ_R-zU61OY6NtPHt',
    model: '琉璃闪耀',
    id: '44',
  },
  {
    typeName: ['棒球'],
    template: 'FlCQiEu66aMrUGRjC6flHkJCEoTx',
    model: '天阙飞鸿',
    id: '45',
  },
  {
    typeName: ['棒球'],
    template: 'Fussp8PsU-b2Dl0E5zww7pZSgjrR',
    model: '红叶追风',
    id: '46',
  },
  {
    typeName: ['足球'],
    template: 'Fv8GRcW4Z-gW840kh4M9Rl0RylGY',
    model: '阳光体育',
    id: '47',
  },
  {
    typeName: ['足球'],
    template: 'Fr1FtdD5H7FQuRANR2rcV8Z4kAlD',
    model: '金色梦想',
    id: '48',
  },
  {
    typeName: ['足球', '*'],
    template: 'Fhv-qR7GRb9iwfPusHRLwORgVifU',
    model: '黄金荣耀',
    id: '49',
  },
  {
    typeName: ['足球', '*'],
    template: 'FkE9dVDowZwy5tjV8LtsLlULBiD1',
    model: '紫电光盾',
    id: '50',
  },
  {
    typeName: ['足球', '*'],
    template: 'FkMVbE4TvSuL7g7X1NiG214TqUOX',
    model: '电光蓝剑',
    id: '51',
  },
  {
    typeName: ['足球', '*'],
    template: 'Fhzd7UvHZTiIWR4aO5SXl5eyXzok',
    model: '极寒锋卫',
    id: '52',
  },
  {
    typeName: ['足球', '*'],
    template: 'Fls4zZiquTLEIGErJKe95WBIsW5i',
    model: '翡翠绿焰',
    id: '53',
  },
  {
    typeName: ['足球', '*'],
    template: 'FpQ_EipOmQIImvY5qLMli-dy5nJC',
    model: '夜幕辉影',
    id: '54',
  },
  {
    typeName: ['足球', '*'],
    template: 'Fik_O927qS08X_G_0AA-co7mQoWR',
    model: '烈焰破晓',
    id: '55',
  },
  {
    typeName: ['足球', '*'],
    template: 'FnHxCytAKUgoIAkaFvlmAbxUiqdQ',
    model: '红钻炫锋',
    id: '56',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fme_Ez6TkTLKjLlOs1djTXyHLS8S',
    model: '紫电光盾',
    id: '57',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fmgw2BA-umHILu5WKgZraeEHaV_5',
    model: '烈焰破晓',
    id: '58',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FtHQ7huszV2EExwn1uGtH7HJoO3N',
    model: '炫影蓝魔',
    id: '59',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fv2BV9mlLGYX_badra792_Q3eCxK',
    model: '金色绿茵',
    id: '60',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fi_xVrGYlPK_o6KrIJzwOx6PBvs3',
    model: '黄金荣耀',
    id: '61',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FqMX2UnY_ymA_CDocdsNWXzYimx7',
    model: '电光蓝剑',
    id: '62',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FkPv6xn5tvj8Mibvyu5ufQJ4Hi-p',
    model: '翡翠绿焰',
    id: '63',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FqKHVGMv-Fr1HzCmKXwHLhC_4wGZ',
    model: '暗金之刃',
    id: '64',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FvK_NoimK7cTMxtqm66uMA5Lnhbv',
    model: '夜幕辉影',
    id: '65',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FvpFmCgpzR4ZsCRFm0s5-tzqsVBO',
    model: '红钻炫锋',
    id: '66',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FjIz9sYiT9IPCzNHHkY8WgQu_B3U',
    model: '疾速闪耀-盾形',
    id: '67',
  },
  {
    typeName: ['海丝杯'],
    template: 'Fn0CTROKXspAV73Gk9Q8QIH6y7h-',
    model: '海丝杯-球员卡',
    id: '68',
  },
  {
    typeName: '欧洲杯',
    model: '塞尔维亚',
    template: 'Fgo_mwtJ6MvhpOmz2wv_hFeVDxR6',
    id: '78',
  },
  {
    typeName: '欧洲杯',
    model: '韩国',
    template: 'FuLhhZHVsHx9O1NV33x6H5tZ8CJU',
    id: '79',
  },
  {
    typeName: '欧洲杯',
    model: '日本',
    template: 'FqspMoAAy9GNCii_jp8G3STVqK7B',
    id: '80',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fm_Vl6_NEbdFnfEXq6YOQ1AkUNT7',
    model: '蝙蝠军团',
    id: '81',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Ft8zU5f8XNFaHaJLQd0x73KfZrdY',
    model: '床单军团',
    id: '82',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FiMbHCSz-wnxncpd4VvTbnIFM66N',
    model: '红蓝军团',
    id: '83',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FtxYjuKfCq9oAOP4P0882o00emB4',
    model: '蓝白军团',
    id: '84',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FjXf8gDZ-_V5vryvb8JYRcWmbLZa',
    model: '南大王',
    id: '85',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FvvRfSYXkwZwozFJZa2rZV_Jzyti',
    model: '喜鹊',
    id: '86',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FiWt8ONwjGpkIG35ipLLk0rsb-gP',
    model: '银河战舰',
    id: '87',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FmTWEJ2O41pZUudSTQbzPrTfnL-9',
    model: '巴斯克雄狮',
    id: '88',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fv9Fx8AeTF8WfgZ3nvAWczsUAwOf',
    model: '白百合',
    id: '89',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Frtn1nVUcnLPK1yx4DZghAasqRmv',
    model: '兵工厂',
    id: '90',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FhD-2jzB7ndV0X-oPZvgyt8LAt7n',
    model: '斧头帮',
    id: '91',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FjiryhteuwXErOgGrMlQRfRpmYMl',
    model: '红军',
    id: '92',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FvlAVnqiOsHkw-KheP94E-Qp2q0d',
    model: '红魔',
    id: '93',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FlPxztqBq9Qshyo0rqu3qiWCApe6',
    model: '蓝军',
    id: '94'
  },
  {
    typeName: ['参赛纪念'],
    template: 'FnebZLk4zKjy_c9BkK_sEnLuO6aE',
    model: '蓝月亮',
    id: '95',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FjAmuuhjH2R7-9IBH8ti43JUZqwa',
    model: '大黄蜂',
    id: '96',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FjeuGAlbtx-Y8fj4kO3Po2YLxqQ2',
    model: '红牛',
    id: '97',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fq9V0e99DxXmMFqJ4BdbcpRsFLHv',
    model: '老鹰',
    id: '98',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FqzaH8huGGCvCtIJ8qpHgHXeilhp',
    model: '里昂',
    id: '99',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FiMhA_5_AAxgJeMg-cCB4735AI4A',
    model: '马塞',
    id: '100',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FgNzAfX3SN-VOnFEd_xmiKBxJubB',
    model: '斯图加特',
    id: '101',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FrLoyqTtHVvV1jGSgKSmSdPEPi4z',
    model: '药厂',
    id: '102'
  },
  {
    typeName: ['参赛纪念'],
    template: 'FpyI7uJDpGSXBlw0F8UzlysuWrN3',
    model: 'PSG',
    id: '103',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fj6Q287d37kqCaHBRNCfbwFQREvw',
    model: '红河军团',
    id: '104'
  },
  {
    typeName: ['参赛纪念'],
    template: 'FsEIXpB8iUbs8ovVvcumsFzSiz6y',
    model: '红狼',
    id: '105',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FoVK_gWNoLs9qm7Zb9gVJ7tZznPk',
    model: '蓝黑军团',
    id: '106',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fm4Ct3JwZ00JfCTHzYzuDv8iYfra',
    model: '蓝鹰',
    id: '107',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fs_ueGBWdbxhe4JgH3SyIS1W62_e',
    model: '老妇人',
    id: '108',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FgjeY1aPcvHJzfH0ny6_DHpX0rpL',
    model: '摩纳哥',
    id: '109',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FrtzfF-sRS9Ez1efJFWy0W4Mp1lu',
    model: '女神',
    id: '110',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fq-lT57eIBX6YLTPCzHlawAC80n1',
    model: '紫百合',
    id: '111',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FrVeQJvZJdoPboeB08kU6XL-3SbI',
    model: '埃因霍温',
    id: '112',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fvkg6b1s7lwZPrqMumSl2j9-DbrH',
    model: '本菲卡',
    id: '113',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FpWzkehVIBd1FSBs22bReUSvBKRE',
    model: '波尔图',
    id: '114',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fu9XZgsxyDsqttRk40OBzMW7QGq1',
    model: '费耶诺德',
    id: '115',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FtuMMb0IoxRXPiRmTz11HG8QXNMw',
    model: '贾府',
    id: '116',
  },
  {
    typeName: ['参赛纪念'],
    card: 'FscsoWm18IAkny3NXv3I40SYrw0N', // 主卡面图片
    template: 'FscsoWm18IAkny3NXv3I40SYrw0N',
    model: '那不勒斯',
    id: '117',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fme_wXjcNzhH4-Eoc7x3Xh3zxglL',
    model: '葡萄牙体育',
    id: '118',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FoZGa353iodOUd-XYB7rJVRnF-e7',
    model: '上海申花',
    id: '119',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FhHCW2jVpcYPHC4MfumLvAQLtKXt',
    model: '北京国安',
    id: '120',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FvAwIYKVaNvKQZpB_kk6o658a5mm',
    model: '成都蓉城',
    id: '121',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FmA6eNqZ3g6i5yIRY-YAOhIZ1RlS',
    model: '河床',
    id: '122',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FlimEIkQGqQeXuOkAgpUzPbp2IJt',
    model: '利雅得胜利',
    id: '123'
  },
  {
    typeName: ['参赛纪念'],
    template: 'FosXkWCuISrgx1wcS4rfO2eEyHq0',
    model: '迈阿密国际',
    id: '124',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FrNQnT73YOdfIhWMezAlAV1WJDgN',
    model: '山东泰山',
    id: '125',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fr1rj6ZYXn9f_AcobX171hRKCSd5',
    model: '上海上港',
    id: '126',
  },
  {
    typeName: ['参赛纪念'],
    template: 'Fmw3MLgR2BA9om6Pf2ZF9Ya1TCch',
    model: '武汉三镇',
    id: '127',
  },
  {
    typeName: ['参赛纪念'],
    template: 'FvmHhUFXvO9rpDoYHR8VizTr8onV',
    model: '博卡青年',
    id: '128',
  },
  {
    typeName: '欧洲杯',
    model: '德国',
    template: 'FiU9kHdYEvZ7L5YEiI9F0wE6YYfR',
    id: '1',
  },
  {
    typeName: '欧洲杯',
    template: 'FuKRk4jp7vfEMAMqMF6zHGrOvfIe',
    model: '法国',
    id: '2',
  },
  {
    typeName: '欧洲杯',
    template: 'FneapIEACeEc9BmLmJ40F7iHTdWz',
    model: '比利时',
    id: '3'
  },
  {
    typeName: '欧洲杯',
    model: '英格兰',
    template: 'FgOo_J_fY1QDwVzWEeMFojwuXoH7',
    id: '4',
  },
  {
    typeName: '欧洲杯',
    model: '葡萄牙',
    template: 'lhmqnCWsnFETYjryGh0WIBtZhF6T',
    id: '5',
  },
  {
    typeName: '欧洲杯',
    model: '荷兰',
    template: 'Fnept1RdR0oniK_vsTJ8ANi1M4lf',
    id: '6',
  },
  {
    typeName: '欧洲杯',
    model: '西班牙',
    template: 'FiG7LNT1rrduTpt4WoXHmY3Hw4L8',
    id: '7',
  },
  {
    typeName: '欧洲杯',
    model: '瑞士',
    template: 'FrJSH4HwyXCeyQhpyaqowOGwCgwx',
    id: '8',
  },
  {
    typeName: '欧洲杯',
    model: '克罗地亚',
    template: 'Fg9baol0zKb00xY_35UuOOjwCp8U',
    id: '9',
  },
  {
    typeName: '欧洲杯',
    model: '意大利',
    template: 'Fh31lITvjoK1ttFGinWIkM9zpTdf',
    id: '10',
  },
  {
    typeName: '欧洲杯',
    model: '丹麦',
    template: 'FlCfTIt0rhuCCx1U4vbSKVNJkEY-',
    id: '11',
  },
  {
    typeName: '欧洲杯',
    model: '匈牙利',
    template: 'FoTLXvqEXV5lu7aQrnJuuplMD8R8',
    id: '12',
  },
  {
    typeName: '欧洲杯',
    template: 'FmFgqQ9DkzaaUAPIS19qTVklT_BR',
    model: '苏格兰',
    id: '13',
  },
  {
    typeName: '欧洲杯',
    template: 'FsP3kbnl2XY0V1QuP25LeseMzV8x',
    model: '塞尔维亚',
    id: '14',
  },
  {
    typeName: '欧洲杯',
    template: 'FneyUjjBfTsVrQPyPO61d0Y4EUam',
    model: '波兰',
    id: '15'
  },
  {
    typeName: '欧洲杯',
    template: 'FkuS_mxwFZ0CE9BzUui3NTjCuuAp',
    model: '捷克',
    id: '16',
  },
  {
    typeName: '欧洲杯',
    template: 'Fh2PxLEVGs2pXbsQ6gzuEMgVYRSv',
    model: '奥地利',
    id: '17',
  },
  {
    typeName: '欧洲杯',
    template: 'FrZX4ooQcknC6qRCJ3GpOA1YBCtl',
    model: '土耳其',
    id: '18',
  },
  {
    typeName: '欧洲杯',
    template: 'FgaaOQliZhHnMmkB5z4Wm9YlPcMg',
    model: '乌克兰',
    id: '19',
  },
  {
    typeName: '欧洲杯',
    template: 'FrqAkhp6hyxMWmoOzaPUiPslMBnj',
    model: '斯洛伐克',
    id: '20',
  },
  {
    typeName: '欧洲杯',
    template: 'FsfR-aJcUIDJc87zX7a1sj01kx_k',
    model: '罗马尼亚',
    id: '21',
  },
  {
    typeName: '欧洲杯',
    template: 'FukkRrWeXm7JSmn5vjIRKiKI5Twd',
    model: '斯洛文尼亚',
    id: '22',
  },
  {
    typeName: '欧洲杯',
    model: '阿尔巴尼亚',
    template: 'FgPPm0TJpsazyIrjji_R9MjxHSUt',
    id: '23',
  },
  {
    typeName: '欧洲杯',
    template: 'Fupgl5GyJ5hWIAADbJIonJSVr_sf',
    model: '格鲁吉亚',
    id: '24',
  },
  {
    typeName: '欧洲杯',
    model: '中国',
    template: 'FhvBR2p_T0Ul6uLDhFuUxSKSSYEY',
    id: '129',
  },
  {
    typeName: '欧洲杯',
    model: '阿根廷',
    template: 'Fj7SjvY3IckKvygjTM6m8Ky-enVt',
    id: '130',
  },
  {
    typeName: '欧洲杯',
    model: '巴西',
    template: 'FqvPoVC4xQCMWqmqgGpJr_lAQ06F',
    id: '131',
  },
  {
    typeName: '欧洲杯',
    model: '哥伦比亚',
    template: 'FmxiLT09nJ0HWIkpzpzVQl35F8X5',
    id: '132'
  },
  {
    typeName: '欧洲杯',
    model: '美国',
    template: 'FlDQD0sbBxmm5GSkBNmaMvsyQTi0',
    id: '133',
  },
  {
    typeName: '欧洲杯',
    model: '墨西哥',
    template: 'Fr7md1CvphqjCuoydQv-v6mhILgo',
    id: '134'
  },
  {
    typeName: '欧洲杯',
    model: '尼日利亚',
    template: 'FvZHpTlvji-ifTRB2w7mjG9-tmHM',
    id: '135',
  },
  {
    typeName: '欧洲杯',
    model: '乌拉圭',
    template: 'FqfVQwclQAjvsKBUTKtTAUT6-kuA',
    id: '136'
  }
]

// 赛事卡
const matchCardList = [
  {
    typeName: ['篮球'],
    template: 'FuByXdRNGO5GI_HX_hf0-AblMxok',
    model: '篮梦星辰',
    id: '69',
  },
  {
    typeName: ['篮球'],
    template: 'FrUlYieEsCUZ-Gc4Xn941plluQtm',
    model: '篮韵悠扬',
    id: '70',
  },
  {
    typeName: ['足球'],
    template: 'lpA0Su-_HYf3oGEb8JxF2ZewCS1c',
    model: '紫梦幻影',
    id: '71',
  },
  {
    typeName: ['足球'],
    template: 'FpCRto-eQgNgaSWib3C5Yr3PYBI-',
    model: '铁马冰河',
    id: '72',
  },
  {
    typeName: ['橄榄球'],
    template: 'FpTes2wSB75ybKVAguqNKJYz2RNg',
    model: '紫金巅峰',
    id: '73',
  },
  {
    typeName: ['橄榄球'],
    template: 'Fk5bH241fOgOkh1YdC1DaG0Cqaub',
    model: '城市腰约',
    id: '74'
  },
  {
    typeName: ['海丝杯'],
    template: 'Flmzz4UAwdnIMLqTcid3cdhpfFI0',
    model: '海丝杯-比赛卡',
    id: '75'
  },
]

export {
  playerList,
  matchCardList,
}